import { APIData, keys, appFetch } from ".";

type Image = {
  id: number;
  website_key: keys;
  image: string;
  created_at: string;
};
export interface Settings {
  website_key: keys;
  about_us_title: string;
  about_us_description: string;
  vision: string;
  our_message: string;
  principles: string;
  address: string;
  cv: string;
  phone: string;
  email: string;
  fax: string;
  facebook: string;
  instagram: string;
  linkedin: string;
  twitter: string;
  youtube: string;
  whatsapp: string;
  website_images?: Image[];
  structure_image: string;
}
export const settingsAPI = {
  fetch(key: keys) {
    return appFetch<APIData<Settings>>("/settings", {
      headers: {
        "WEBSITE-KEY": key,
      },
    });
  },
};
